import styled from 'styled-components';

export default styled.div`
  p {
    margin-bottom: 10px;
  }

  span {
    display: block;
    line-height: 20px;
    cursor: default !important;
  }

  .row {
    align-items: baseline;
    justify-content: space-between;

    & > div {
      width: 47%;
    }
  }

  .infos {
    div p {
      color: #838488;
      font-size: 13px;
      line-height: 20px;
    }
  }

  ul {
    margin-bottom: 32px;

    & > li {
      margin-bottom: 10px;

      & > div {
        &:before {
          top: 2px;
        }
      }

      span  {
        color: #e6e7e7;
      }

      &:not(:last-child)::before {
        top: 9px;
        height: 25px;
      }
      &:last-child::before {
        content: '';
        left: 7px;
        top: 20px;
        width: 1px;
        height: 10;
        display: block;
        position: absolute;
        background-color: #2e3136;
      }
    }
  }
`;
